





















import {Component, Prop} from "vue-property-decorator"
import BaseVue from "@/utils/BaseVue"
import {ProductListRef, StoreInfo} from "@/services/models.types"
import {StoreData} from "@/store/stores.module"
import logger from "@/utils/logging"

@Component
export default class ProductListSelector extends BaseVue {
    @Prop() private productListId!: string
    @Prop() private storeId!: number

    private mounted() {
        if (this.productListId === undefined && this.storeData.info.availableLists.length > 0) {
            logger.debug(`Auto selecting store's first product list: #${this.storeData.info.availableLists[0].id}`)
            this.$router.replace({
                name: "productListEditor",
                params: {productListId: this.storeData.info.availableLists[0].id},
            })
        }
    }

    private get items(): Array<ProductListRef & { enabledProductsCount: number }> {
        // Compute the number of enabled product counts for each list
        const counts = new Map<string, number>()
        this.storeData.enabledProducts.forEach((enabledProduct) => {
            counts.set(enabledProduct.listId, (counts.get(enabledProduct.listId) || 0) + 1)
        })

        // Prepare the list of product list info together with count of enabled products
        return this.storeData.info.availableLists
            .map((listRef: ProductListRef) => {
                return {
                    ...listRef,
                    enabledProductsCount: counts.get(listRef.id) || 0,
                }
            })
            .sort((item1, item2) => {
                return (item2.enabledProductsCount > 0 ? 1 : 0) - (item1.enabledProductsCount > 0 ? 1 : 0)
            })
    }

    private get storeData(): StoreData {
        return this.$typedStore.state.stores[this.storeId].data!
    }

    private itemIconSrc(item: ProductListRef) {
        return require(`@/assets/${item.category}.svg`)
    }
}
